module.exports = __webpack_public_path__ + "img/nd.76db6ed5.svg";